<template>
  <v-container grid-list-md fluid>
    <!--Index-->
    <v-layout v-if="!dialog" wrap justify-center align-center>
      <v-flex xs12 sm8>
        <span class="display-1">{{ formTitle }}</span>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          class="elevation-1"
          :rows-per-page-items="[100, 50, 25, { text: 'Todos', value: -1 }]"
          rows-per-page-text="Registros por página"
          no-data-text="Não existem registros"
          no-results-text="Nenhum registro encontrado"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.id_texto }}</td>
            <td>{{ props.item.observacao }}</td>
            <td align="center">
              <v-btn
                icon
                class="mx-0"
                @click="editItem(props.item)"
                :disabled="!hasAccess(entity, 'update')"
              >
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <v-btn
                icon
                class="mx-0"
                @click="deleteItem(props.item, props.item.id, true)"
                :disabled="!hasAccess(entity, 'delete')"
                v-if="props.item.id_texto != $auth.user().anobase.id_texto"
              >
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="pageText" slot-scope="props">
            {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <!--Create Edit-->
    <v-layout v-else wrap justify-center align-center>
      <v-flex xs12>
        <span class="display-1">{{ formTitle }}</span>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          name="id_texto"
          :label="translate('table.' + entity + '.field.id_texto')"
          v-model="editedItem.id_texto"
          :error-messages="errors.collect('id_texto')"
          v-validate="'required'"
          counter
          maxlength="4"
          data-vv-as="Ano"
        ></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-text-field
          name="observacao"
          multi-line
          :label="translate('table.' + entity + '.field.observacao')"
          v-model="editedItem.observacao"
          :error-messages="errors.collect('observacao')"
          v-validate="'max:191'"
          data-vv-as="Observação"
        ></v-text-field>
      </v-flex>
    </v-layout>

    <v-snackbar :top="true" :right="true" :timeout="6000" v-model="snackbar.active" color="error">
      {{ snackbar.text }}
      <v-btn flat @click.native="snackbar = false">Fechar</v-btn>
    </v-snackbar>

    <v-btn
      v-if="view === 1"
      color="primary"
      dark
      fab
      fixed
      bottom
      right
      :disabled="!hasAccess(entity, 'create')"
      @click="create"
    >
      <v-icon>{{ this.translate("system.button.add.icon") }}</v-icon>
    </v-btn>

    <v-layout v-else class="fab-container" align-center>
      <v-speed-dial v-if="view === 2" v-model="fab" open-on-hover>
        <v-btn v-model="fab" slot="activator" fab color="primary" dark :disabled="saving" :loading="saving" @click="save()">
          <v-icon>{{ this.translate("system.button.add.icon") }}</v-icon>
          <v-icon>{{ this.translate("system.button.save.icon") }}</v-icon>
        </v-btn>

        <v-tooltip left>
          <v-btn slot="activator" fab small color="secondary" :disabled="saving" :loading="saving" @click="saveNew()">
            <v-icon>{{ this.translate("system.button.save_new.icon") }}</v-icon>
          </v-btn>
          <span>{{ this.translate("system.button.save_new.title") }}</span>
        </v-tooltip>
      </v-speed-dial>

      <v-btn v-if="view === 3" color="primary" dark fab @click="saveAnoBase()">
        <v-icon>{{ this.translate("system.button.done.icon") }}</v-icon>
      </v-btn>

      <v-btn fab small @click="close">
        <v-icon>{{ this.translate("system.button.close.icon") }}</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<style scoped>
tr td:last-child {
  min-width: 130px;
}

.fab-container {
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 10;
}
</style>

<script>
import crud from "./../../mixin/crud";
import acl from "./../../mixin/acl";

export default {
  mixins: [crud, acl],
  data: () => ({
    fab: null,
    entity: "anobase",
    snackbar: {
      active: false,
      text: "Não foi possível excluir o registro",
    },
  }),
  created: function () {
    this.initialize();
  },
  methods: {
    afterSave() {
      location.reload();
    },
    deleteItem(item) {
      const index = this.items.indexOf(item);
      if (confirm(this.translate("system.alert.delete"))) {
        this.$http.delete(`api/${this.entity}/${item.id}`).then(
          (response) => {
            this.items.splice(index, 1);
          },
          (response) => {
            console.log(response);
            this.snackbar.active = true;
          }
        );
      }
      setTimeout(function () {
        location.reload();
      }, 1000);
    },
  },
  computed: {
    headers: function () {
      return [
        { text: this.translate("table." + this.entity + ".field.id_texto"), value: "id_texto" },
        { text: this.translate("table." + this.entity + ".field.observacao"), value: "observacao" },
        {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
        },
      ];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/crud/AnoBase.vue